module.exports = __webpack_public_path__ + "img/다카야마라이브.33140655.jpg";